import React, { Component } from 'react';
import { Route, Redirect } from 'react-router';
import { filterActions } from '../../data/actions/filter'
import {Widget, WithWidgetManager, HiddenElements} from '../../components/widgets/manager';
import YoutubeTimeseries from '../../components/pages/youtube/YoutubeTimeseries';
import YoutubeTracks from '../../components/pages/youtube/YoutubeTracks';
import YoutubeSources from '../../components/pages/youtube/YoutubeSources';
import YoutubeTerritories from '../../components/pages/youtube/YoutubeTerritories';


class ResultYoutube extends Component {
	constructor(props) {
		super(props);
		this.state = {
			filterInitialized: false
		}
	}
	
	
	render() {
		const { flatFilter, widgetProps, sharedMode } = this.props;
		
		return <div className="inner-page">
			{!sharedMode && <div className="widget-row">
				<HiddenElements widgetProps={widgetProps} />
			</div>}

			<div className="widget-row widget-row--full-width">
				<Widget widgetID="youtube_views" widgetProps={widgetProps}>
					<YoutubeTimeseries filtered={flatFilter} shadowChartProps={{id: 'audience_youtube_line_chart', shadowChartWidth: 800, shadowChartHeight: 300}}/>
				</Widget>
			</div>
			
			<div className="widget-row widget-row--full-width">
				<Widget widgetID="youtube_tracks" widgetProps={widgetProps}>
					<YoutubeTracks filtered={flatFilter} shadowChartProps={{id: 'audience_youtube_pie_chart', shadowChartWidth: 800, shadowChartHeight: 300}} />
				</Widget>
			</div>

			
			
			<div className="widget-row widget-row--full-width">
				<Widget widgetID="youtube_sources" widgetProps={widgetProps}>
					<YoutubeSources filtered={flatFilter} shadowChartProps={{id: 'audience_youtube_pie_chart', shadowChartWidth: 800, shadowChartHeight: 300}} />
				</Widget>
			</div>


			<div className="widget-row widget-row--full-width">
				<Widget widgetID="youtube_territories" widgetProps={widgetProps}>
					<YoutubeTerritories filtered={flatFilter} shadowChartProps={{id: 'audience_youtube_territories_line_chart', shadowChartWidth: 800, shadowChartHeight: 300}}/>
				</Widget>
			</div>

		</div>
	}
}

export default WithWidgetManager(ResultYoutube, 'result_youtube')